define([
	"dojo/_base/declare",
	"canvas/widgets/interfaces/model/enumerations/PlaceholderTextFormat",
	"csi/html",
	"csi/widget/RadioToggleButton",
	"./_Plugin",
], function(declare, {PlaceholderTextFormat}, html, RadioToggleButton, _Plugin) {

	return declare([RadioToggleButton, _Plugin], {
		radioClass: "svgPlaceholderTextFormat",

		/**
		 * Apply style
		 * @param  {Event} e
		 */
		onClick: function(e) {
			const { editor } = this;
			editor.canvasApp.canvasApi().setPlaceholderTextFormat(this.enumValue);
			const labelToggleNode = editor.view.toolbarNode.containerNode.querySelector(".csi-canvas-plugin-group-ToggleLabels");
			html.setVisible(labelToggleNode.parentElement, this.enumValue !== PlaceholderTextFormat.VALUE);
			editor.updateToolbar();
		},
	});
});
